import { render, staticRenderFns } from "./ProductOverviewDesc.vue?vue&type=template&id=7f1bdf64&scoped=true"
import script from "./ProductOverviewDesc.vue?vue&type=script&lang=ts"
export * from "./ProductOverviewDesc.vue?vue&type=script&lang=ts"
import style0 from "./ProductOverviewDesc.vue?vue&type=style&index=0&id=7f1bdf64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1bdf64",
  null
  
)

export default component.exports